// Nav.tsx - navigation : marque, les trois sections de l'accueil, un CTA.
// Les liens de section pointent vers de vraies ancres (`/#qui`…) : ils restent
// copiables, ouvrables dans un nouvel onglet et lisibles par un moteur de
// recherche - le JS ne fait qu'intercepter le clic pour défiler en douceur.
import type { MouseEvent, ReactElement } from "react";
import type { Path } from "../lib/router";
import { CONTACT_MAILTO } from "../lib/constants";

interface NavProps {
  navigate: (to: Path) => void;
  /** Navigue vers l'accueil puis fait défiler jusqu'à la section demandée. */
  goSection: (id: string) => void;
}

/** Les sections de l'accueil atteignables depuis la barre de navigation. */
const SECTIONS = [
  { id: "communaute", label: "La communauté" },
  { id: "logiciel", label: "Restaurateurs" },
  { id: "offre", label: "L'offre" },
] as const;

export function Nav({ navigate, goSection }: NavProps): ReactElement {
  const link = (to: Path) => (e: MouseEvent) => {
    e.preventDefault();
    navigate(to);
  };

  return (
    <header className="nav container">
      <a href="/" onClick={link("/")} className="nav-brand" aria-label="Hop Resto - accueil">
        <img src="/hop-resto-logo-long.png" alt="Hop Resto" className="nav-logo" height={58} />
      </a>
      <nav className="nav-links" aria-label="Navigation principale">
        {SECTIONS.map((s) => (
          <a
            key={s.id}
            href={`/#${s.id}`}
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              goSection(s.id);
            }}
          >
            {s.label}
          </a>
        ))}
        {/* Plus de page « Restaurateurs » : le formulaire a été retiré le
            6 septembre 2026, on écrit directement à SUPPORT_EMAIL. */}
        <a href={CONTACT_MAILTO} className="btn btn-primary btn-sm">
          Nous écrire
        </a>
      </nav>
    </header>
  );
}
